import React, { useState } from "react";
import { Button, Drawer, Form, Input } from "@payping/web-components";
import { useAppSelector, useAppTranslation } from "@/utils";
import { Close } from "@payping/icons";
import EditActionButtons from "@/components/mobile/settings/EditActionButtons";
import { DashboardRoutes } from "@/router/constant";
import { isBirthCertificateDisabled } from "@/mobile/Settings/Personal/Edit/isBirthCertificateDisabled";
import { useHandleNavigationURL, useSaveToRedux } from "@/mobile/Settings/Personal/utils";
import { settingsPersonalAtom } from "../../state";
import { selectAtom } from "jotai/utils";
import { useAtom } from "jotai";

const mobileFormEditAtom = selectAtom(settingsPersonalAtom, (val) => val.mobileFormEdit);

const MobileEditPersonalBirthCertificateNumber: React.FC = () => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(true);
  const [form] = Form.useForm();
  const { t } = useAppTranslation();

  const [mobileFormEditState] = useAtom(mobileFormEditAtom);

  const birthCertificateNumberApi = useAppSelector((state) => state.user.personalInfo?.birthCertificateNumber);

  const [birthCertificateNumber, setBirthCertificate] = useState<string | undefined>();

  // Custom Hooks
  const { handleNavigationURL } = useHandleNavigationURL();
  const { saveToRedux } = useSaveToRedux();

  return (
    <>
      <Drawer
        open={isDrawerOpen}
        title={`${t("edit")} / ${t("profile.birthCertificateNumber")}`}
        height={"100%"}
        placement={"bottom"}
        closeIcon={false}
        extra={<Button type={"text"} icon={<Close width={14} height={14} />} onClick={handleNavigationURL} />}
      >
        <Form
          onFinish={() =>
            saveToRedux({
              nextUrlForMobileRegisterURL: DashboardRoutes.register.mEditPersonal.nationalCode.url,
              fieldName: "birthCertificateNumber",
              fieldValue: birthCertificateNumber,
              setIsDrawerOpen,
            })
          }
          form={form}
          initialValues={{
            birthCertificateNumber: mobileFormEditState.birthCertificateNumber ?? birthCertificateNumberApi,
          }}
        >
          <Form.Item name="birthCertificateNumber" rules={[{ required: true }]}>
            <Input
              value={birthCertificateNumber}
              placeholder={t("mobileEditPersonal.enterName")}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => setBirthCertificate(e.target.value)}
              disabled={isBirthCertificateDisabled()}
            />
          </Form.Item>
        </Form>
      </Drawer>
      <EditActionButtons onAccept={form.submit} />
    </>
  );
};
export default MobileEditPersonalBirthCertificateNumber;
